import { intervalToDuration } from 'date-fns'

const formatDuration = (seconds: number) => {
  if (seconds > 0 && seconds < 60) {
    return '1min'
  }
  const duration = intervalToDuration({ start: 0, end: seconds * 1000 })
  if (duration.days) {
    return `${duration.days}d:${duration.hours}h:${duration.minutes}min`
  }
  if (duration.hours) {
    return `${duration.hours}h:${duration.minutes}min`
  }
  return `${duration.minutes || 0}min`
}

export default formatDuration
